import { useId } from 'react';
import { T, useGT } from 'gt-react';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface Props {
  sheetNames: string[];
  value: string | null;
  disabled: boolean;
  onChange: (sheetName: string) => void;
}

/**
 * The sheet of a many-sheet workbook being converted, e.g. one Division tab of
 * Hubbell's FINAL.xlsx; changing it reads and re-converts that sheet.
 */
export function SheetPicker({ sheetNames, value, disabled, onChange }: Props) {
  const gt = useGT();
  const labelId = useId();
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm">
      <span id={labelId}>
        <T context="label before the picker of which workbook sheet (tab) to convert">
          Sheet
        </T>
      </span>
      <Select
        value={value ?? ''}
        onValueChange={(next) => {
          if (typeof next === 'string' && next !== '') onChange(next);
        }}
      >
        <SelectTrigger
          className="h-8 w-44"
          disabled={disabled}
          aria-labelledby={labelId}
        >
          <SelectValue
            placeholder={gt('Choose a sheet', {
              context: 'placeholder of the workbook sheet picker',
            })}
          />
        </SelectTrigger>
        <SelectContent>
          {sheetNames.map((name) => (
            <SelectItem key={name} value={name}>
              {name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
